import React, { createContext, useReducer, useContext } from "react";
import reducer from "./reducers";
import { useActions } from "./actions";
import * as initialState from "./initialState";

const StoreContext = createContext(initialState);

export const StoreProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const actions = useActions(state, dispatch);

  return (
    <StoreContext.Provider
      children={children}
      value={{
        ...state,
        actions,
        dispatch,
      }}
    />
  );
};

export function useStore() {
  return useContext(StoreContext);
}
